import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateWorkspacePlan } from "api/services/workspace-plan-service";
import { ISaveWorkspacePlanRequest } from "api/models/request/workspacePlan/ISaveWorkspacePlanRequest";
import { IWorkspacePlanModel } from "api/models/response/workspacePlan/IWorkspacePlanModel";
import { useAuthContext } from "hooks/useAuthContext";
import { WORKSPACE_PLANS_QUERY_KEY, WORKSPACE_SUBSCRIPTION_QUERY_KEY } from "hooks/workspacePlan/queryKeys";

export const useUpdateWorkspacePlan = () => {
    const queryClient = useQueryClient();
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const mutation = useMutation({
        mutationFn: async (request: { planId: string } & ISaveWorkspacePlanRequest): Promise<IWorkspacePlanModel> => {
            const response = await updateWorkspacePlan({ workspaceId, ...request });
            if (!response.success || !response.data) {
                throw new Error(response.message ?? "subscriptionPlan.updateError");
            }

            return response.data;
        },
        onSuccess: (updatedPlan) => {
            queryClient.setQueryData<IWorkspacePlanModel[]>(WORKSPACE_PLANS_QUERY_KEY, (prev) =>
                prev?.map((plan) => (plan.id === updatedPlan.id ? updatedPlan : plan))
            );
            queryClient.invalidateQueries({ queryKey: WORKSPACE_PLANS_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: WORKSPACE_SUBSCRIPTION_QUERY_KEY });
        },
    });

    return {
        updatePlan: mutation.mutateAsync,
        updatingPlan: mutation.isPending,
    };
};
